import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';


//Mansory - Bento grid
import Masonry from 'react-masonry-css';

//Key Features
import features_01 from '../../assets/img/landingPage/management/APIManagement_01.png';
import features_02 from '../../assets/img/landingPage/virtualServer/VS_0.png'

//Iconos
import icn_01 from '../../assets/img/landingPage/management/icn_management_01.png';
import icn_02 from '../../assets/img/landingPage/management/icn_management_02.png';
import icn_03 from '../../assets/img/landingPage/management/icn_management_03.png';
import icn_04 from '../../assets/img/landingPage/management/icn_management_04.png';
import icn_05 from '../../assets/img/landingPage/management/icn_management_05.png';
import icn_06 from '../../assets/img/landingPage/management/icn_management_06.png';
import icn_07 from '../../assets/img/landingPage/management/icn_management_07.png';
import icn_08 from '../../assets/img/landingPage/management/icn_management_08.png';

import fondo from '../../assets/img/landingPage/fondo.png';
import ReactGA from 'react-ga4'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

//Importaciones de otros archivos, revisar y borrar
import gradientApi from '../../assets/img/landingPage/gradientApi.png'
import gradientServices from '../../assets/img/landingPage/gradientServices.png'

import product_gateway from '../../assets/img/landingPage/Gateway.png'
import dashboard from '../../assets/img/landingPage/CicloVida.png';


const APIManagement = () => {


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    const productDetailsA = {
        Key_Feature_01: {
            title: 'Open and universal',
            text: "Create, virtualize, govern, and secure any API, from any provider, platform, or environment. Avoid vendor lock-in and unify your API strategy with a virtual-first architecture.",
            altDescription: "Create, virtualize, govern, and secure any API, from any provider, platform, or environment.",
            image: features_01,
        },
        Key_Feature_02: {
            title: "AI-driven API strategy",
            text: "Build a smarter API program with help from AVAP’s Gen-AI engine. AVAP Framework recommends security policies, predicts performance issues, and helps you govern APIs at scale, with less effort.",
            altDescription: "Build a smarter API program with help from AVAP’s Gen-AI engine.",
            image: features_02,
        },
        /*Key_Feature_03: {
            title: 'Trusted by modern teams',
            text: 
            "AVAP Framework is already helping developers and architects rethink how APIs are managed,  modular, intelligent, and efficient. Join the teams that are using AVAP to:  ",
            features: [
                "Automate API lifecycle tasks.",
                "Improve delivery speed.",
                "Cut down operational load.",
                "Scale without infrastructure friction."
              ],
            altDescription: 'AVAP Framework is already helping developers and architects rethink how APIs are managed,  modular, intelligent, and efficient.',
            image: product_gateway,
        },*/
    }
    
    //Key Benefits Bento
    const items = [
        {
          icon: icn_01,
          title: 'Deliver better customer experiences, faster',
          paragraphs: [
            'AVAP enables seamless experiences by reusing APIs, simplifying rollout, and accelerating launches.',
          ],
        },
        {
          icon: icn_02,
          title: 'Your API ecosystem, in one platform',
          paragraphs: [
            'Discover and simulate APIs instantly, no production impact, no manual setup.',
          ]
        },

        {
          icon: icn_03,
          title: 'Design and test without dependencies',
          paragraphs: [
            'Model Virtual APIs with AVAP tools; validate performance without full setup.',
          ]
        },
        {
          icon: icn_04,
          title: 'Unify APIs through virtual architecture',
          paragraphs: [
            'Expose unified GraphQL or REST endpoints without backend rewrites using AVAP.'
          ]
        },
        {
          icon: icn_05,
          title: 'Achieve consistent quality and compliance',
          paragraphs: [
            'Enforce adaptive, granular security with real-time AI-driven access control in AVAP.',
          ]
        },
        {
            icon: icn_06,
            title: 'Insightful analytics',
            paragraphs: [
              'Monitor usage, latency, and errors. Optimize performance with smart dashboards.',
            ]
          },
          
      ];
      
    const breakpointColumnsObj = {
        default: 3, //Cambio de columnas verticales
        1100: 2,
        700: 1
      
    };



      
    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}>

                {/* Hero Section */}
                <section  id="heroProduct" className="text-center py-5">
                    <h1 className="fl-title-big m-0">API & MCP Management</h1>
                    <p className="fl-title m-0 gradient-text">Advanced, Virtual API Lifecycle Management</p>
                                <p className="fl-text fl-txt-container-s" >
                                Accelerate development and reduce complexity with AVAP Framework’s intelligent, universal API management solution.
                                </p>
                                <p className="fl-text fl-txt-container-s" >
                                Built for speed and powered by virtualization and Gen-AI, AVAP API Management helps you take full control of any API, no matter where or how it was built.
                                </p>
                </section>
                
                {/* Subtítulo descripción */}
                <section className="text-center pb-5">
                    <img
                        src={dashboard}
                        className="img-fluid mt-4"
                        style={{ width: '70%', maxWidth: '800px', height: 'auto' }}
                    />
                    
                    <h2 className="fl-title m-0 gradient-text fl-title m-4 pt-8">A virtual-first platform for managing any API</h2>
                                <p className="fl-subtitle fl-txt-container-s">
                                AVAP API Management brings the power of intelligent automation and native virtualization to your entire API ecosystem.
                                </p>
                    <p className="fl-text text-center fl-txt-container-s">
                    Whether you're dealing with legacy REST endpoints, GraphQL services, or third-party APIs, manage them all from a single, intuitive control panel, with zero-code overhead.
                    </p>
                </section>
                
                {/* Sección Key Features */}
                <div className="fl-wrapper">
                    <img src={gradientServices} className="gradient gradientServices" alt="" />
                    <img src={gradientApi} alt="" className="gradient gradientlife" />
                    <div className="fl-container">
                        <section id="products">
                            {/*   <h3 className="fl-title text-center">Our Products & Services</h3> */}
                            
                            <div className="fl-productsWrapper">
                                {Object.keys(productDetailsA).map((productKey, index) => (
                                    <div key={productKey} className="fl-product-item">
                                        <div className={`row align-items-center ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}>
                                            <div className="col-md-6">
                                                <div className="product-content">
                                                    <h3 className="fl-subtitle">
                                                        {productDetailsA[productKey].title}
                                                    </h3>
                                                    <p className="fl-text">
                                                        {productDetailsA[productKey].text}
                                                    </p>
                                                    {/* Lista de bullets para features */}
                                                    {productDetailsA[productKey].features && (
                                                    <ul className="fl-bullets fl-text fl-txt-container-s">
                                                        {productDetailsA[productKey].features.map((feature, i) => (
                                                        <li key={i}>{feature}</li>
                                                         ))}
                                                    </ul>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <img
                                                    src={productDetailsA[productKey].image}
                                                    alt={productDetailsA[productKey].altDescription}
                                                    className="img-fluid product-preview"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    </div>
                </div>

                {/* Sección Built */} 
                <section className="container">
                    <div className="row">
                        <div className="col">
                            <div className="blobContainer mb-8 mt-4 text-center">

                                <div className="blob"></div>
                                <div className="">
                                    <h3 className='fl-title'>Trusted by modern teams</h3>
                                    <p>AVAP Framework is already helping developers and architects rethink how APIs are managed, modular, intelligent, and efficient. Join the teams that are using AVAP to:
                                    </p>
                                    {/* Sección Bullets */}
                                    <ul className="fl-bullets-built text-center" >
                                    <li className="fl-bullets">Automate API lifecycle tasks.</li>
                                    <li className="fl-bullets">Improve delivery speed.</li>
                                    <li className="fl-bullets">Cut down operational load.</li>
                                    <li className="fl-bullets">Scale without infrastructure friction.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                {/* Sección Key Benefits // 2 columnas // fondo azul */}   
                 {/*<section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col mb-5">
                            <div className="fl-title text-center mb-3">
                                Key Benefits
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-6">
                            <div className="fl-card text-center grayBox mb-4" >
                            
                                <img
                                src={icn_01}
                                alt="Icon representing 01."
                                className="mb-3 solutionsIcon"
                                />
                                
                                <p className="fl-subtitle-xs">
                                Deliver better customer experiences, faster
                                </p>
                                <p className="fl-text">
                                Companies across industries are using AVAP Framework to power seamless, omnichannel experiences by:   
                                </p>
                               
                                <ul className="fl-bullets fl-text fl-txt-container-s" style={{ marginLeft: "7px" }}>
                                <li className="fl-bullets">Reusing APIs through virtualization.</li>
                                <li className="fl-bullets">Simplifying version control and rollout.</li>
                                <li className="fl-bullets">Accelerating time to market for new services.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="fl-card text-center grayBox mb-4">
                      
                                <img
                                src={icn_02}
                                alt="Icon representing 01."
                                className="mb-3 solutionsIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Everything your API ecosystem needs, in one platform
                                </p>
                                <p className="fl-text">
                                Discover and simulate APIs instantly.
                                </p>
                                <p className="fl-text">
                                Automatically identify existing APIs across your repositories or pipelines and simulate them in isolated environments, all before touching production code.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="fl-card text-center grayBox mb-4">
                              
                                <img
                                src={icn_03}
                                alt="Icon representing 01."
                                className="mb-3 solutionsIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Design and test without dependencies
                                </p>
                                <p className="fl-text">
                                Use AVAP Dev Studio or AVAP CLI to model Virtual APIs using your preferred protocols.
                                </p>
                                <p className="fl-text">
                                Validate structure, governance, and performance without setting up full environments.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="fl-card text-center grayBox mb-4">
                               
                                <img
                                src={icn_04}
                                alt="Icon representing 01."
                                className="mb-3 solutionsIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Unify APIs through virtual architecture
                                </p>
                                <p className="fl-text">
                                Expose unified GraphQL endpoints or REST facades without rewriting backends, powered by AVAP’s API Wrapped native virtual layer.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="fl-card text-center grayBox mb-4">
                             
                                <img
                                src={icn_05}
                                alt="Icon representing 01."
                                className="mb-3 solutionsIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Achieve consistent quality and compliance
                                </p>
                                <p className="fl-text">
                                Security without compromise.
                                </p>
                                <p className="fl-text">
                                Enforce granular authentication, rate limits, and access policies, by user, app, or environment. AVAP Framework’s AI engine adapts controls in real time.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="fl-card-s text-center grayBox mb-4">
                                
                                <img
                                src={icn_06}
                                alt="Icon representing 01."
                                className="mb-4 solutionsIcon"
                                /> <br/>
                                <p className="fl-subtitle-xs">
                                Insightful analytics
                                </p>
                                <p className="fl-text">
                                Track key metrics like consumption, latency, and error rates. Identify top consumers and optimize performance using intelligent dashboards.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="fl-card-s text-center grayBox">
                               
                                <img
                                src={icn_07}
                                alt="Icon representing 01."
                                className="mb-3 solutionsIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Build your API ecosystem
                                </p>
                                <p className="fl-text">
                                Grow adoption with secure discovery.
                                </p>
                                <p className="fl-text">
                                Group and publish APIs in internal or public portals with automated documentation and access rules.
                                </p>
                                <p className="fl-text">
                                Drive collaboration, monetization and reusability with AVAP Marketplace and Dev Portal.
                                </p>
                            </div>
                        </div>
                    

                    </div>
                </section>*/}


                {/*CAJAS 2 COLUMNAS, ICONO CENTRADO, FONDO GRIS, TITULO Y PÁRRAFO */}
             
             
            {/*<div className="container">
                    <div className="fl-title text-center mb-5">
                    Key Benefits
                    </div>
                <div className="row">

                    --- Caja 1 --- comentar
                    <div className="col-md-6 d-flex">
                    <div className="fl-card grayGradient text-center">
                        <img
                        src={icn_01}
                        alt="Icon representing 01"
                        className="solutionsIcon"
                        />
                        <p className="fl-subtitle-xs text-center">
                        Deliver better customer experiences, faster</p>
                        <p className="fl-text text-center">
                        Companies across industries are using AVAP Framework to power seamless, omnichannel experiences by:</p>
                            
                            // Sección Bullets
                            <ul className="fl-bullets fl-text fl-txt-container-s" style={{ marginLeft: "7px" }}>
                                <li className="fl-bullets">Reusing APIs through virtualization.</li>
                                <li className="fl-bullets">Simplifying version control and rollout.</li>
                                <li className="fl-bullets">Accelerating time to market for new services.</li>
                            </ul>                       
                    </div>
                    </div>


                    --- Caja 2 --- comentar
                    <div className="col-md-6 d-flex">
                    <div className="fl-card grayGradient text-center">
                        <img
                        src={icn_02}
                        alt="Icon representing 02"
                        className="solutionsIcon"
                        />
                        <p className="fl-subtitle-xs">Everything your API ecosystem needs, <br/>in one platform</p>
                        <p className="fl-text text-center">Discover and simulate APIs instantly.</p>
                        <p className="fl-text">
                        Automatically identify existing APIs across your repositories or pipelines and simulate them in isolated environments, all before touching production code.
                        </p>
                    </div>
                    </div>


                    --- Caja 3 --- comentar
                    <div className="col-md-6 d-flex">
                    <div className="fl-card text-center grayGradient">
                        <img
                        src={icn_03}
                        alt="Icon representing 03"
                        className="solutionsIcon"
                        />
                        <p className="fl-subtitle-xs">Design and test without dependencies</p>
                        <p className="fl-text">Use AVAP Dev Studio or AVAP CLI to model Virtual APIs using your preferred protocols.</p>
                        <p className="fl-text">
                        Validate structure, governance, and performance without setting up full environments.
                        </p>
                    </div>
                    </div>


                    --- Caja 4 --- comentar
                    <div className="col-md-6 d-flex">
                    <div className="fl-card text-center grayGradient">
                        <img
                        src={icn_04}
                        alt="Icon representing 03"
                        className="solutionsIcon"
                        />
                        <p className="fl-subtitle-xs">Unify APIs through virtual architecture</p>
                        <p className="fl-text">Expose unified GraphQL endpoints or REST facades without rewriting backends, powered by AVAP’s API Wrapped native virtual layer.</p>
                    </div>
                    </div>


                    --- Caja 5 --- comentar
                    <div className="col-md-6 d-flex">
                    <div className="fl-card text-center grayGradient">
                        <img
                        src={icn_05}
                        alt="Icon representing 03"
                        className="solutionsIcon"
                        />
                        <p className="fl-subtitle-xs">Achieve consistent quality and compliance</p>
                        <p className="fl-text">Security without compromise.</p>
                        <p className="fl-text">Enforce granular authentication, rate limits, and access policies, by user, app, or environment. AVAP Framework’s AI engine adapts controls in real time.</p>
                    </div>
                    </div>
                </div>
                </div> 
                */}


                {/*MASONRY 2 COLUMNAS, ICONO CENTRADO, FONDO GRIS, TITULO Y PÁRRAFO */}
                <div className="container">
                <div className="fl-title text-center mb-5">
                    Key Benefits
                    </div>
                    <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="masonry-grid"
                    columnClassName="masonry-column"
                    >
                    {items.map((item, idx) => (
                        <div key={idx} className="fl-card-s text-center grayGradient">
                        <img src={item.icon} alt="Icon representing 0X" className="solutionsIcon" />
                        <p className="fl-subtitle-xs">{item.title}</p>
                        {item.paragraphs.map((p, i) => (
                            <p key={i} className="fl-text">{p}</p>
                        ))}
                       
                            </div>
                    ))}
                    </Masonry>
                </div>

            


                {/* Sección built for secure */} 
               {/*<section className="container">
                    <div className="row">
                        <div className="col">
                            <div className="blobContainer mb-8 mt-4">

                                <div className="blob"></div>
    

                                <div className="rightBC">
                                    <h3 className='fl-title'>Build your API ecosystem</h3>
                                    <p>Grow adoption with secure discovery.
                            
                                    </p>
                                    <p>Group and publish APIs in internal or public portals with automated documentation and access rules.
                                    </p>
                                    <p>Drive collaboration, monetization and reusability with AVAP Marketplace and Dev Portal.
                                    </p>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>*/}

            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default APIManagement;
